(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
// Define Showcase object
if ((typeof Showcase) === 'undefined') { Showcase = {}; }

// Add event handlers (callbacks)
Showcase.loadMedia = function(media) {
  if (media.length > 0) {
	$('.showcase-product-gallery').addClass('visible');
  }
};

  } catch(e) { console.error(e); }
})();
})();
